(function(){
  var MO_EU=[[22,35],[22.5,35.5],[23,36],[23.5,37],[24,38],[24.5,39],[25,39.5],[25.5,40],[26,41],[26.5,41.5],[27,42],[27.5,43],[28,44],[28.5,44.5],[29,45],[29.5,46],[30,47]];
  var EU_UK={35:3,35.5:3,36:3.5,36.5:4,37:4,37.5:4.5,38:5,38.5:5.5,39:6,39.5:6,40:6.5,40.5:7,41:7.5,41.5:8,42:8,42.5:8.5,43:9,43.5:9.5,44:9.5,44.5:10,45:10.5,45.5:11,46:11,47:12};
  var EU_US={35:4,35.5:4.5,36:5,36.5:5,37:5.5,37.5:6,38:6.5,38.5:7,39:7,39.5:7.5,40:7.5,40.5:8,41:8.5,41.5:9,42:9,42.5:9.5,43:10,43.5:10,44:10.5,44.5:11,45:11.5,45.5:11.5,46:12,47:13};
  var UK_EU={3:35.5,3.5:36,4:36.5,4.5:37,5:38,5.5:38.5,6:39,6.5:40,7:40.5,7.5:41,8:42,8.5:42.5,9:43,9.5:43.5,10:44,10.5:44.5,11:45,11.5:45.5,12:46,13:47};
  var US_EU={4:35,4.5:35.5,5:36,5.5:37,6:38,6.5:38.5,7:39,7.5:40,8:40.5,8.5:41,9:42,9.5:42.5,10:43,10.5:44,11:44.5,11.5:45,12:46,13:47};

  function sgMO2EU(mo){for(var i=0;i<MO_EU.length;i++){if(mo<=MO_EU[i][0])return MO_EU[i][1];}return 47;}
  function sgEU2MO(eu){var c=MO_EU[0];for(var i=0;i<MO_EU.length;i++){if(Math.abs(MO_EU[i][1]-eu)<Math.abs(c[1]-eu))c=MO_EU[i];}return c[0];}
  function sgToEU(v,unit){v=parseFloat(v);if(unit==='mo')return sgMO2EU(v);if(unit==='eu')return v;if(unit==='uk')return UK_EU[v]||null;if(unit==='us')return US_EU[v]||null;return null;}
  function sgTabla(h,w){var b=h-14;if(w>=90)b+=3;else if(w<=55)b-=3;else if(w>=75)b+=1;return Math.round(b)+'-'+(Math.round(b)+5)+' cm';}

  // Brand-specific binding sizing
  var FIJACION_BRANDS={
    union:function(eu){
      if(eu<=37)return 'XS';
      if(eu<=40.5)return 'S';
      if(eu<=43)return 'M';
      if(eu<=46)return 'L';
      return 'XL';
    },
    rome:function(eu){
      if(eu<=39)return 'S';
      if(eu<=43)return 'M';
      if(eu<=46)return 'M/L';
      return 'L/XL';
    },
    jones:function(eu){
      if(eu<=41)return 'S';
      if(eu<=44)return 'M';
      return 'L';
    },
    thirtytwo:function(eu){
      if(eu<=41)return 'S';
      if(eu<=44)return 'M';
      return 'L';
    },
    nidecker:function(eu){
      if(eu<=36)return 'S';
      if(eu<=41)return 'M';
      if(eu<=44.5)return 'L';
      return 'XL';
    },
    ride:function(eu){
      if(eu<=40.5)return 'S';
      if(eu<=43.5)return 'M';
      return 'L';
    },
    _default:function(eu){
      if(eu<=41)return 'S / M';
      if(eu<=44)return 'M / L';
      return 'L / XL';
    }
  };

  function sgFijacion(eu, brand){
    brand=(brand||'').toLowerCase().replace(/[^a-z]/g,'');
    var fn=FIJACION_BRANDS[brand]||FIJACION_BRANDS._default;
    return fn(eu);
  }

  var _sgBU='mo',_sgFU='eu',_sgBrand='';

  var SG_HTML={};
  SG_HTML.bota='<h2 style="font-size:1.15rem;font-weight:900;margin:0 0 .5rem">Calcula tu talla de bota</h2><p style="font-size:.85rem;color:#777;margin:0 0 1rem;line-height:1.7">Elige el sistema que conoces e introduce tu medida.</p><div style="display:flex;border-bottom:1px solid #e0e0e0;margin-bottom:1.2rem"><button class="sg-ut sg-act" data-sg-unit="mo">MO (cm)</button><button class="sg-ut" data-sg-unit="eu">EU</button><button class="sg-ut" data-sg-unit="uk">UK</button><button class="sg-ut" data-sg-unit="us">US</button></div><div style="display:flex;gap:.6rem;align-items:center;margin-bottom:.8rem"><input id="sg-b-val" type="number" min="18" max="34" step="0.5" placeholder="ej. 26.5" style="border:1.5px solid #111;padding:.7rem .9rem;font-size:1rem;font-family:inherit;width:130px"><span id="sg-b-ulbl" style="font-size:.85rem;color:#999">cm</span><button id="sg-b-calc" style="background:#111;color:#fff;border:none;padding:.7rem 1.5rem;font-size:.85rem;font-weight:700;cursor:pointer;font-family:inherit">Calcular</button></div><div id="sg-b-res" style="display:none;padding:1rem;background:#f5f5f5;border-left:3px solid #111;margin-bottom:1.5rem"></div><a href="/pages/guia-de-tallas#botas" style="display:block;text-align:center;border:1px solid #ddd;padding:.7rem;font-size:.85rem;color:#666;text-decoration:none">Ver tabla completa</a>';
  SG_HTML.tabla='<h2 style="font-size:1.15rem;font-weight:900;margin:0 0 .5rem">Calcula tu talla de tabla</h2><p style="font-size:.85rem;color:#777;margin:0 0 1.5rem;line-height:1.7">La longitud ideal depende de tu altura y peso.</p><div style="display:grid;grid-template-columns:1fr 1fr;gap:.75rem;margin-bottom:1rem"><div><label style="font-size:.75rem;color:#999;display:block;margin-bottom:.35rem">Altura (cm)</label><input id="sg-t-h" type="number" min="130" max="210" placeholder="ej. 172" style="border:1.5px solid #111;padding:.7rem .9rem;font-size:1rem;font-family:inherit;width:100%"></div><div><label style="font-size:.75rem;color:#999;display:block;margin-bottom:.35rem">Peso (kg)</label><input id="sg-t-w" type="number" min="30" max="140" placeholder="ej. 70" style="border:1.5px solid #111;padding:.7rem .9rem;font-size:1rem;font-family:inherit;width:100%"></div></div><button id="sg-t-calc" style="background:#111;color:#fff;border:none;padding:.7rem 1.5rem;font-size:.85rem;font-weight:700;cursor:pointer;font-family:inherit;margin-bottom:1rem">Calcular</button><div id="sg-t-res" style="display:none;padding:1rem;background:#f5f5f5;border-left:3px solid #111;margin-bottom:1.5rem"></div><a href="/pages/guia-de-tallas#tablas" style="display:block;text-align:center;border:1px solid #ddd;padding:.7rem;font-size:.85rem;color:#666;text-decoration:none">Ver guia de tablas</a>';

  function sgFijHtml(brand){
    var bname=(brand||'').toUpperCase()||'tu marca';
    return '<h2 style="font-size:1.15rem;font-weight:900;margin:0 0 .3rem">Calcula tu talla de fijacion</h2>'+
    '<p style="font-size:.8rem;color:#888;margin:0 0 .8rem">Tallas especificas para <strong>'+bname+'</strong></p>'+
    '<p style="font-size:.85rem;color:#777;margin:0 0 1rem;line-height:1.7">Introduce la talla de tu bota.</p>'+
    '<div style="display:flex;border-bottom:1px solid #e0e0e0;margin-bottom:1.2rem">'+
    '<button class="sg-ut sg-act" data-sg-unit="mo" data-sg-ctx="fij">MO (cm)</button>'+
    '<button class="sg-ut" data-sg-unit="eu" data-sg-ctx="fij">EU</button>'+
    '<button class="sg-ut" data-sg-unit="uk" data-sg-ctx="fij">UK</button>'+
    '<button class="sg-ut" data-sg-unit="us" data-sg-ctx="fij">US</button>'+
    '</div>'+
    '<div style="display:flex;gap:.6rem;align-items:center;margin-bottom:.8rem">'+
    '<input id="sg-f-val" type="number" min="18" max="50" step="0.5" placeholder="ej. 26.5" style="border:1.5px solid #111;padding:.7rem .9rem;font-size:1rem;font-family:inherit;width:130px">'+
    '<span id="sg-f-ulbl" style="font-size:.85rem;color:#999">cm</span>'+
    '<button id="sg-f-calc" style="background:#111;color:#fff;border:none;padding:.7rem 1.5rem;font-size:.85rem;font-weight:700;cursor:pointer;font-family:inherit">Calcular</button>'+
    '</div>'+
    '<div id="sg-f-res" style="display:none;padding:1rem;background:#f5f5f5;border-left:3px solid #111;margin-bottom:1.5rem"></div>'+
    '<a href="/pages/guia-de-tallas#fijaciones" style="display:block;text-align:center;border:1px solid #ddd;padding:.7rem;font-size:.85rem;color:#666;text-decoration:none">Ver tabla completa</a>';
  }

  SG_HTML.casco='<h2 style="font-size:1.15rem;font-weight:900;margin:0 0 .5rem">Guia de tallas de casco</h2><p style="font-size:.85rem;color:#777;margin:0 0 1.5rem;line-height:1.7">Mide el perimetro de tu cabeza con una cinta metrica a la altura de la frente.</p><a href="/pages/guia-de-tallas#cascos" style="display:block;text-align:center;background:#111;color:#fff;padding:.9rem;font-size:.9rem;font-weight:700;text-decoration:none">Ver tabla de cascos</a>';
  SG_HTML.general='<h2 style="font-size:1.15rem;font-weight:900;margin:0 0 .5rem">Guia de tallas</h2><p style="font-size:.85rem;color:#777;margin:0 0 1.5rem;line-height:1.7">Consulta nuestra guia completa.</p><a href="/pages/guia-de-tallas" style="display:block;text-align:center;background:#111;color:#fff;padding:.9rem;font-size:.9rem;font-weight:700;text-decoration:none">Ver guia de tallas</a>';

  function sgInjectStyles(){
    if(document.getElementById('sg-styles'))return;
    var s=document.createElement('style');
    s.id='sg-styles';
    s.textContent='.sg-ut{padding:.4rem 1rem;border:none;background:none;cursor:pointer;font-size:.8rem;font-weight:700;border-bottom:2px solid transparent;color:#aaa;font-family:inherit;transition:all .15s}.sg-act{border-bottom-color:#111 !important;color:#111 !important}';
    document.head.appendChild(s);
  }

  function sgBuildDOM(){
    if(document.getElementById('sg-popup'))return;
    sgInjectStyles();
    var ov=document.createElement('div');
    ov.id='sg-overlay';
    ov.style.cssText='display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9998';
    document.body.appendChild(ov);
    var pp=document.createElement('div');
    pp.id='sg-popup';
    pp.style.cssText='display:none;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:min(600px,96vw);max-height:88vh;overflow-y:auto;background:#fff;z-index:9999;padding:2.5rem 2rem 2rem;box-shadow:0 20px 60px rgba(0,0,0,.3)';
    var cb=document.createElement('button');
    cb.id='sg-close';
    cb.style.cssText='position:absolute;top:10px;right:10px;background:#111;color:#fff;border:none;width:36px;height:36px;font-size:20px;cursor:pointer;font-family:inherit;line-height:1';
    cb.textContent='x';
    var ct=document.createElement('div');
    ct.id='sg-content';
    pp.appendChild(cb);
    pp.appendChild(ct);
    document.body.appendChild(pp);
    ov.addEventListener('click',window.sgClose);
    cb.addEventListener('click',window.sgClose);
  }

  window.sgOpen=function(type, brand){
    sgBuildDOM();
    _sgBU='mo';_sgFU='mo';
    _sgBrand=brand||'';
    var ct=document.getElementById('sg-content');
    if(!ct)return;
    if(type==='fijacion'){
      ct.innerHTML=sgFijHtml(_sgBrand);
    } else {
      ct.innerHTML=SG_HTML[type]||SG_HTML.general;
    }
    document.getElementById('sg-overlay').style.display='block';
    document.getElementById('sg-popup').style.display='block';
    document.body.style.overflow='hidden';
    var bc=document.getElementById('sg-b-calc');
    if(bc)bc.addEventListener('click',window.sgRunBota);
    var tc=document.getElementById('sg-t-calc');
    if(tc)tc.addEventListener('click',window.sgRunTabla);
    var fc=document.getElementById('sg-f-calc');
    if(fc)fc.addEventListener('click',window.sgRunFijacion);
  };

  window.sgClose=function(){
    var ov=document.getElementById('sg-overlay');
    var pp=document.getElementById('sg-popup');
    if(ov)ov.style.display='none';
    if(pp)pp.style.display='none';
    document.body.style.overflow='';
  };

  window.sgRunBota=function(){
    var inp=document.getElementById('sg-b-val');
    if(!inp||!inp.value)return;
    var eu=sgToEU(parseFloat(inp.value),_sgBU);
    if(!eu)return;
    var mo=sgEU2MO(eu),uk=EU_UK[eu]||'-',us=EU_US[eu]||'-';
    var el=document.getElementById('sg-b-res');
    if(!el)return;
    el.innerHTML='<div style="margin-bottom:.5rem;font-size:.7rem;text-transform:uppercase;letter-spacing:.1em;color:#999">Talla recomendada</div><div style="display:grid;grid-template-columns:repeat(4,1fr);gap:4px"><div style="padding:.6rem .3rem;background:#111;color:#fff;text-align:center"><div style="font-size:.6rem;opacity:.7;margin-bottom:.2rem">MO</div><strong>'+mo+' cm</strong></div><div style="padding:.6rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.6rem;color:#888;margin-bottom:.2rem">EU</div><strong>'+eu+'</strong></div><div style="padding:.6rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.6rem;color:#888;margin-bottom:.2rem">UK</div><strong>'+uk+'</strong></div><div style="padding:.6rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.6rem;color:#888;margin-bottom:.2rem">US</div><strong>'+us+'</strong></div></div>';
    el.style.display='block';
  };

  window.sgRunTabla=function(){
    var h=parseFloat((document.getElementById('sg-t-h')||{}).value);
    var w=parseFloat((document.getElementById('sg-t-w')||{}).value);
    if(!h||h<100)return;
    var el=document.getElementById('sg-t-res');
    if(!el)return;
    el.innerHTML='Rango recomendado: <strong style="font-size:1.2rem">'+sgTabla(h,w||70)+'</strong>';
    el.style.display='block';
  };

  window.sgRunFijacion=function(){
    var inp=document.getElementById('sg-f-val');
    if(!inp||!inp.value)return;
    var eu=sgToEU(parseFloat(inp.value),_sgFU);
    if(!eu)return;
    var size=sgFijacion(eu, _sgBrand);
    var mo=sgEU2MO(eu);
    var uk=EU_UK[eu]||'-';
    var us=EU_US[eu]||'-';
    var el=document.getElementById('sg-f-res');
    if(!el)return;
    el.innerHTML='<div style="margin-bottom:.6rem;font-size:.72rem;text-transform:uppercase;letter-spacing:.1em;color:#999">Tu talla de fijacion</div>'+
      '<div style="display:flex;align-items:center;gap:1rem;flex-wrap:wrap">'+
      '<div style="padding:.8rem 2rem;background:#111;color:#fff;font-size:1.6rem;font-weight:900;letter-spacing:.02em">'+size+'</div>'+
      '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:4px;font-size:.8rem">'+
      '<div style="padding:.4rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.58rem;color:#888;margin-bottom:.1rem">MO</div><strong>'+mo+' cm</strong></div>'+
      '<div style="padding:.4rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.58rem;color:#888;margin-bottom:.1rem">EU</div><strong>'+eu+'</strong></div>'+
      '<div style="padding:.4rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.58rem;color:#888;margin-bottom:.1rem">UK</div><strong>'+uk+'</strong></div>'+
      '<div style="padding:.4rem .3rem;background:#f0f0f0;text-align:center"><div style="font-size:.58rem;color:#888;margin-bottom:.1rem">US</div><strong>'+us+'</strong></div>'+
      '</div></div>';
    el.style.display='block';
  };

  // Fijacion unit tracker
  var _sgFU_ctx='fij';

  // Event delegation
  document.addEventListener('click',function(e){
    // Open popup
    var ob=e.target.closest('[data-sg-open]');
    if(ob){
      var brand=ob.getAttribute('data-sg-brand')||'';
      window.sgOpen(ob.getAttribute('data-sg-open'),brand);
      return;
    }
    // Boot unit tabs
    var bu=e.target.closest('[data-sg-unit]:not([data-sg-ctx])');
    if(bu){
      _sgBU=bu.getAttribute('data-sg-unit');
      document.querySelectorAll('[data-sg-unit]:not([data-sg-ctx])').forEach(function(b){b.classList.remove('sg-act');});
      bu.classList.add('sg-act');
      var cfg={mo:{ph:'ej. 26.5',min:18,max:34,lbl:'cm'},eu:{ph:'ej. 41',min:33,max:50,lbl:'EU'},uk:{ph:'ej. 7.5',min:2,max:14,lbl:'UK'},us:{ph:'ej. 9',min:3,max:15,lbl:'US'}};
      var c=cfg[_sgBU]||cfg.mo;
      var i=document.getElementById('sg-b-val');
      if(i){i.placeholder=c.ph;i.min=c.min;i.max=c.max;i.value='';}
      var l=document.getElementById('sg-b-ulbl');if(l)l.textContent=c.lbl;
      var r=document.getElementById('sg-b-res');if(r)r.style.display='none';
      return;
    }
    // Fijacion unit tabs (ctx=fij)
    var fu=e.target.closest('[data-sg-ctx="fij"]');
    if(fu){
      _sgFU=fu.getAttribute('data-sg-unit');
      document.querySelectorAll('[data-sg-ctx="fij"]').forEach(function(b){b.classList.remove('sg-act');});
      fu.classList.add('sg-act');
      var mo_min=18,eu_min=33;
      var cfg2={mo:{ph:'ej. 26.5',min:18,max:34,lbl:'cm'},eu:{ph:'ej. 41',min:33,max:50,lbl:'EU'},uk:{ph:'ej. 7.5',min:2,max:14,lbl:'UK'},us:{ph:'ej. 9',min:3,max:15,lbl:'US'}};
      var c2=cfg2[_sgFU]||cfg2.mo;
      var i2=document.getElementById('sg-f-val');
      if(i2){i2.placeholder=c2.ph;i2.min=c2.min;i2.max=c2.max;i2.value='';}
      var l2=document.getElementById('sg-f-ulbl');if(l2)l2.textContent=c2.lbl;
      var r2=document.getElementById('sg-f-res');if(r2)r2.style.display='none';
    }
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape')window.sgClose();});
})();
